import { Component } from "@/types/types"
import { cx } from "@/utils/cx"
import { SectionContainer } from "../SectionContainer"

export const COMPONENT_NAME = "splashLayout"

export const presets = {}

export interface Props extends Component {}

export function SplashLayout({ children, className, testId = COMPONENT_NAME }: Props) {
  return (
    <SectionContainer
      className={cx(`w-full flex bg-background pt-8 md:pt-32 lg:pt-32`, className)}
      testId={testId}
    >
      <div className="w-full flex justify-center">{children}</div>
    </SectionContainer>
  )
}
